import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Button } from 'antd';
import Translated from 'components/Translated';
import FieldInput from 'components/Field/Input';
import { getTranslated } from 'utils';
import validate from './Form.validate';

const Form = ({ locale, reseller, userToken, userLogin, handleSubmit }) => {
    const savingLoading = userToken.loading;

    function handleLogin(values) {
        const loginData = {
            username: {
                email: values.email,
                reseller_id: reseller.data ? reseller.data.hits?.[0]?.id : process.env.REACT_APP_ADMIN,
            },
            password: values.password,
        };

        userLogin(loginData);
    }

    return (
        <section className="gx-signin-form gx-form-row0">
            <div className="gx-mb-3">
                <Field
                    name="email"
                    type="text"
                    component={FieldInput}
                    parent={{ className: 'gx-mb-2' }}
                    custom={{
                        onPressEnter: handleSubmit(handleLogin),
                        placeholder: getTranslated('global.email', locale),
                        params: { field: getTranslated('global.email', locale) },
                    }}
                />
            </div>
            <div className="gx-mb-3">
                <Field
                    name="password"
                    type="password"
                    component={FieldInput}
                    parent={{ className: 'gx-mb-2' }}
                    custom={{
                        onPressEnter: handleSubmit(handleLogin),
                        placeholder: getTranslated('global.password', locale),
                        params: {
                            field: getTranslated('global.password', locale),
                            len: 8,
                        },
                    }}
                />
            </div>

            <Button
                htmlType="button"
                type="primary"
                className="gx-mb-3"
                onClick={handleSubmit(handleLogin)}
                loading={savingLoading}
                disabled={savingLoading}
                shape={savingLoading ? 'round' : null}
            >
                { !savingLoading
                    ? (
                        <>
                            <i className="la la-sign-in la-lg" />&nbsp;
                            <Translated id="global.login" />&nbsp;
                        </>
                    ) : <span>&nbsp;<Translated id="global.loading" /></span>
                }
            </Button>
        </section>
    );
};

export default reduxForm({
    form: 'loginForm',
    validate,
    keepDirtyOnReinitialize: true,
    enableReinitialize: true,
    destroyOnUnmount: true,
})(Form);
